import styled from 'styled-components';
import { LogoSVG } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/miscellaneous';
import Button, {
  ButtonLink,
} from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const ContentWrapperStyled = styled.div`
  position: relative;
  top: 0;
`;

const LogoWomStyled = styled(LogoSVG)`
  transform: scale(0.5);
`;

const TitleStyled = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  max-width: 300px;
  color: #0e141d;
`;

const DescStyled = styled.span`
  color: #494c66;
  text-align: center;
  font-size: 14px;
  line-height: 18px;
  font-style: normal;
  font-weight: 400;
  width: 100%;
  max-width: 300px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    max-width: 400px;
  }

  strong {
    font-weight: 700;
  }
`;

const DescLongTextStyled = styled(DescStyled)`
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    max-width: 500px;
  }
`;

const ButtonStyled = styled(Button)`
  display: flex;
  gap: 10px;
  max-width: 230px;
`;

const ButtonLinkStyled = styled(ButtonLink)`
  && {
    font-size: 14px;
    font-weight: 500;
    width: max-content;
    text-underline-offset: 4px;
  }
`;

const LayoutWrapperStyled = styled.div`
  align-items: center;
  background: white;
  display: flex;
  min-height: 100vh;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  :before {
    content: '';
    background: linear-gradient(
      90deg,
      #4e018d 0%,
      #7212e8 46.35%,
      #c348ea 100%
    );
    height: 6px;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const PageTemplateStyled = styled.div`
  width: inherit;

  @media (min-width: 769px) {
    & > *:first-child {
      display: none;
    }
  }
`;

const ListStyled = styled.ul`
  max-width: 400px;

  & > *:not(:last-child) {
    margin-bottom: 24px;
  }

  li {
    font-size: 16px;
    color: #494c66;
    font-weight: 400;
    display: flex;
    gap: 10px;

    svg {
      min-width: 24px;
      position: relative;
      top: 5px;
    }

    span {
      line-height: 20px;
    }

    strong {
      font-weight: 700;
    }
  }
`;

const TitleVariantStyled = styled(TitleStyled)`
  max-width: 400px;
`;

const DescVariantStyled = styled(DescStyled)`
  font-size: 16px;
  line-height: 20px;
  max-width: 400px;
`;

const AdditionalDescStyled = styled(DescVariantStyled)`
  font-size: 14px;
  line-height: 18px;
`;

export {
  LogoWomStyled,
  TitleStyled,
  DescStyled,
  ButtonStyled,
  ButtonLinkStyled,
  LayoutWrapperStyled,
  ContentWrapperStyled,
  PageTemplateStyled,
  TitleVariantStyled,
  DescVariantStyled,
  ListStyled,
  AdditionalDescStyled,
  DescLongTextStyled,
};
